import { Svg, Path } from "@react-pdf/renderer";
export const LeafLogo = (): JSX.Element => {
	return (
		<Svg width="15" height="15" viewBox="0 0 30 30">
			<Path
				d="M5.643 6.985C1.093 11.534 0 26.472 0 26.472s3.102-1.614 8.066-2.025c4.698-.411 9.011-1.057 11.552-3.58 3.93-3.904 4.905-9.421 2.66-13.354-2.453 3.815-12.528 9.274-12.528 9.274C16.989 11.651 20.682 7.66 25.645.646L23.223 0s-1.802 3.258-3.398 4.813c-3.96-2.788-9.986-1.966-14.182 2.172z"
				fill="#399829"
				fill-rule="evenodd"
			/>
		</Svg>
	);
};
